import get from 'lodash/get';

export default function hasRouteTitle(route: any): boolean {
  return !!(get(route, 'title'));
}
